/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';

function ItalicIcon(props, svgRef) {
  return React.createElement("svg", Object.assign({
    "data-sanity-icon": "italic",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M10.43 18H11.7276L13.4551 9.86763H12.1576L10.43 18ZM13.3043 8.29848C13.8022 8.29848 14.2095 7.89111 14.2095 7.39321C14.2095 6.89531 13.8022 6.48794 13.3043 6.48794C12.8064 6.48794 12.399 6.89531 12.399 7.39321C12.399 7.89111 12.8064 8.29848 13.3043 8.29848Z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(ItalicIcon);
export default ForwardRef;